import { getPlayer, getTeam } from "../../utils.js";
import GameFactEventDto from "../GameFactEventDto.js";

export class ReplacementDto extends GameFactEventDto {

    constructor(event){
        super(event);
        this.tab = event.tab ??"REMPLACEMENT"
        this.detail = {
            ...this.detail,
            title : event.detail?.title || "REMPLACEMENT",
            inplayer: event.detail?.inplayer,
            outplayer: event.detail?.outplayer,
          };
    }

    get inplayer() {
        return this.detail.inplayer;
    }
    set inplayer(value) {
        this.detail.inplayer = value;
    }

    get outplayer() {
        return this.detail.outplayer;
    }
    set outplayer(value) {
        this.detail.outplayer = value;
    }

    initTimerPeriod(match){
        super.initTimerPeriod(match)
    }

    updateDetail(key, value, match) {
        super.updateDetail(key, value)
        
        // On peut modifier le text et le title
        if(this.isAutomaticCommentary && ["isAutomaticCommentary", "team", "inplayer", "outplayer"].includes(key)){
            let commentaire = "Remplacement"

            const inPlayer = getPlayer(this.inplayer, match)
            const outPlayer = getPlayer(this.outplayer, match)
            const team = getTeam(this.team, match)

            if(this.inplayer){
                if(inPlayer){
                    commentaire += ' de '+ outPlayer.lastname
                }

                if(this.outplayer){
                    if(outPlayer){
                        commentaire += ' par '+ inPlayer.lastname
                    }
                }
            }else if(team){
                commentaire += ' pour '+ team.name
            }

            commentaire += "."

            this.text = commentaire
        }
    }
}